export default "__VITE_ASSET__DOsD48al__"